var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("search-control", {
        attrs: {
          facets: _vm.facets,
          pagination: _vm.pagination,
          sorting: _vm.sorting,
        },
      }),
      _vm._v(" "),
      _c("product-list", {
        attrs: {
          results: _vm.results,
          pagination: _vm.pagination,
          merchandising: _vm.merchandising,
        },
      }),
      _vm._v(" "),
      _c("pagination", { attrs: { pagination: _vm.pagination } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }